import React from 'react';
import PropTypes from 'prop-types';
export default class FeatureFlagProvider extends React.Component {
  static parseMajorAndMinorVersion(versionNumber) {
    const versions = versionNumber.split('.');
    if (versions.length === 0 || versions.length > 2)
      throw new Error(`Version number - wrong format: ${versionNumber}`);
    return {
      major: parseInt(versions[0]),
      minor: versions.length === 1 ? 0 : parseInt(versions[1])
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      currentVersion:
        props.version && FeatureFlagProvider.parseMajorAndMinorVersion(props.version),
      featureFlags: {}
    };

    this.isFeatureActive = this.isFeatureActive.bind(this);
    this.setCurrentversionNumberAndFeatureFlags =
      this.setCurrentversionNumberAndFeatureFlags.bind(this);
  }

  setCurrentversionNumberAndFeatureFlags(versionNumber, featureFlags, callback) {
    /* When introducing the featureflags based on the yesplan version, the api did include the version number.
     * Therefore it could be undefined when setting it here. */
    if (versionNumber) {
      this.setState(
        {
          currentVersion: FeatureFlagProvider.parseMajorAndMinorVersion(versionNumber),
          featureFlags
        },
        () => {
          if (callback) callback();
        }
      );
    }
  }

  isFeatureActive(featureString) {
    const { currentVersion, featureFlags } = this.state;
    if (!currentVersion) return false;
    if (featureFlags[featureString] === undefined)
      throw new Error(`Could not find feature in configured features: ${featureString}`);
    return featureFlags[featureString];
  }

  render() {
    const { children } = this.props;
    const { currentVersion } = this.state;
    return React.cloneElement(children, {
      isFeatureActive: this.isFeatureActive,
      currentVersionNumber: currentVersion,
      setCurrentversionNumberAndFeatureFlags: this.setCurrentversionNumberAndFeatureFlags
    });
  }
}

FeatureFlagProvider.propTypes = {
  version: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  children: PropTypes.node.isRequired
};

FeatureFlagProvider.defaultProps = {
  version: false
};
